import { Card, Code } from '@blueprintjs/core'
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import image1 from '../../../assets/images/knowledgeTreeMode.gif'
import multipleAnswers1 from '../../../assets/images/multipleAnswers1.png'
import multipleAnswers2 from '../../../assets/images/multipleAnswers2.png'
import { comboTextByOS } from '../../helper/functions'

const updateListRaw = [
  ['Update Notifications', (
    <div>You're seeing it now</div>
  ), '3/23/2021'],
  ['Now it is the default to take notes in the conventional way', (
    <div>
      In the previous approach, users must take notes in question-answer pairs.
      <br />
      However, you can now use LearnObit like any other tree notes.
      <br />
      So now you take notes for reference by default, and take notes for memorizing as before.
      <br />
      <Card className={'fullFill'}><img src={image1} /></Card>
      <b>If you want to create question-answer pairs as before for memorizing, use 'alt + m'.</b>
    </div>
  ), '4/22/2021'],
  ['Auto completion improved', (
    <div>
      Especially, quotes can be auto completed now
    </div>
  ), '4/24/2021'],
  ['Multiple Answers', (
    <>
      {"When the words in the answer part are wrapped in '{{' and '}}'"}
      <img src={multipleAnswers1} />
      <br />
      the count of wrapped words is shown in the learning course, in the Memorize section
      <img src={multipleAnswers2} />
    </>
  ), '5/2/2021'],
  ['Undo / Redo', (
    <>
      <b>Undo</b>: <Code>{comboTextByOS('mod + z')}</Code>
      <br />
      <b>Redo</b>: <Code>{comboTextByOS('mod + shift + z')}</Code> or <Code>{comboTextByOS('mod + y')}</Code>
    </>
  ), '5/19/2021']
]

const updateList = updateListRaw.map((rawInfo) => ({
  title: rawInfo[0],
  description: rawInfo[1],
  date: rawInfo[2]
}))

export const latestUpdateNumber = updateList.length

function AnnounceUpdatePage ({ lastUpdate }) {
  return (
    <Card css={css`
& > * {
  margin-bottom: 2.25rem;
}
box-shadow: none !important;
    `}>
      {updateList.map((updateInfo, updateNumber) => {
        if (!lastUpdate || (updateNumber >= lastUpdate)) {
          return <Card className={'mini'} elevation={2} key={updateInfo.title}>
            <div css={css`font-weight: bold; font-size: 1.5em;`}>{updateInfo.title}</div>
            <br />
            {updateInfo.description}
            <div css={css`text-align: right;`}>{updateInfo.date}</div>
          </Card>
        } else {
          return null
        }
      })}
    </Card>
  )
}

export default AnnounceUpdatePage
